/* eslint-disable react/prop-types */
import Flex from 'components/common/Flex';
import React from 'react';
import { Button, OverlayTrigger, ProgressBar, Tooltip } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { routePaths } from 'routes/routePaths';

function PaymentSteps({ progressCount, setProgressCount, className }) {
  let navigate = useNavigate();

  return (
    <div style={{ width: '44%' }} className={className}>
      <div className="d-flex justify-content-center">
        <div style={{ width: '100%' }}>
          <ProgressBar
            now={progressCount}
            style={{ height: '2px' }}
            className="mb-3 overflow-visible custom-progress-bar"
          />
        </div>
      </div>

      <Flex className="position-relative w-100">
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip
              className="my-tooltip"
              style={{ position: 'fixed' }}
              id="overlay-trigger-example"
            >
              You send 1,000 GBP
              <br />
              Recipient will get 1146.51 EUR
            </Tooltip>
          }
        >
          <Button
            onClick={() => {
              setProgressCount(0);
              navigate(routePaths.HOME);
            }}
            variant="link"
            className="text-decoration-none text-1000 p-0 position-absolute fs--1"
            style={{ left: '-5%' }}
          >
            Amount
          </Button>
        </OverlayTrigger>

        <Button
          variant="link"
          className="text-decoration-none text-1000 p-0 position-absolute fs--1"
          style={{ left: '27.5%' }}
        >
          Recipient
        </Button>

        <Button
          variant="link"
          className="text-decoration-none text-1000 p-0 position-absolute fs--1"
          style={{ left: '62.5%' }}
        >
          Review
        </Button>

        <Button
          variant="link"
          className="text-decoration-none text-1000 p-0 position-absolute fs--1"
          style={{ right: '-2.5%' }}
        >
          Pay
        </Button>
      </Flex>
    </div>
  );
}

export default PaymentSteps;
